module.exports = __webpack_public_path__ + "static/img/main_mypage_icon_g.00ca7505.svg";